import React from 'react';

import './footer.scss'

import logoImg from '../../images/logo.png';
import {Column, Grid} from "@carbon/react";

const Footer = () => (
  <footer className="footer">
    <Grid fullWidth>
      <Column lg={16} md={8} sm={4}>
        <img alt="Freddo & Co." src={logoImg} width="100px"/>
      </Column>
      <Column lg={16} md={8} sm={4}>
        <p style={{fontSize: "14px"}}>Guardian alerting system v{process.env.REACT_APP_VERSION}</p>
      </Column>
    </Grid>
  </footer>
)

export default Footer